import { Component, Input, Output, EventEmitter, OnChanges, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { MinimalPatientAttachment } from 'app/core/models/minimal-patient-attachment.model';
import { OutreachAttemptEvidence } from 'app/core/models/outreach-attempt-evidence.model';
import { canModifyPatientAttachment } from 'app/core/lib/verification-utils';
import { AuthenticationService } from '../../../core/services/authentication.service';

import { OutreachAttemptEvidenceFormComponent } from '../outreach-attempt-evidence-form/outreach-attempt-evidence-form.component';
import { OutreachAttemptEvidenceComponent } from '../outreach-attempt-evidence/outreach-attempt-evidence.component';

@Component({
    selector: 'app-outreach-attempt-evidence-section',
    templateUrl: './outreach-attempt-evidence-section.component.html',
    styleUrls: ['./outreach-attempt-evidence-section.component.scss'],
    imports: [OutreachAttemptEvidenceFormComponent, OutreachAttemptEvidenceComponent]
})
export class OutreachAttemptEvidenceSectionComponent implements OnChanges {
  private authService = inject(AuthenticationService);

  @Input() capture: Capture;
  @Input() patientAttachments: MinimalPatientAttachment[];

  @Output() newPatientAttachment = new EventEmitter<PatientAttachment>();

  outreachAttemptEvidence: OutreachAttemptEvidence;

  showSection = false;
  showAddOutreachAttemptEvidenceForm = false;

  ngOnChanges() {
    if (this.patientAttachments) {
      const bestOutreachAttemptEvidenceAttachment =
        this.determineBestOutreachAttemptEvidenceAttachment(this.patientAttachments);

      this.outreachAttemptEvidence = bestOutreachAttemptEvidenceAttachment?.outreachAttemptEvidence;
    }

    this.showSection =
      this.capture.client.outreachAttemptEvidenceEnabled &&
      canModifyPatientAttachment(this.authService, this.capture);
  }

  onAddOutReachAttemptEvidenceClick($event) {
    $event.preventDefault();
    this.showAddOutreachAttemptEvidenceForm = true;
  }

  onAddOutReachAttemptEvidenceCanceled() {
    this.showAddOutreachAttemptEvidenceForm = false;
  }

  onNewPatientAttachment(newPatientAttachment: PatientAttachment) {
    this.showAddOutreachAttemptEvidenceForm = false;

    this.newPatientAttachment.emit(newPatientAttachment);
  }

  private determineBestOutreachAttemptEvidenceAttachment(patientAttachments: MinimalPatientAttachment[]) {
    if (this.capture.verifyingPatientAttachmentId) {
      return patientAttachments.find(attachment => attachment.id === this.capture.verifyingPatientAttachmentId);
    }

    return patientAttachments.find(attachment =>
      attachment.id === this.capture.bestOutreachAttemptEvidencePatientAttachmentId
    );
  }
}
